<template>
  <!-- 项目经历 -->
  <!-- ApplyForAJob和IndividualEdit都等于1时 正常显示求职意向 若有一条不等于1说明用户点击了添加或单条编辑 这时就要展示编辑栏 -->
  <div :class="IndividualEdit == 1 ? 'normal' : 'editor'">
    <div class="Title-Add-box">
      <div class="Title-Add" @click="handelClickEDITOR"></div>
      <p class="Title-p" @click="handelClickEDITOR">添加项目经历</p>
    </div>
    <!-- 正常展示 项目经历 -->
    <div v-if="IndividualEdit == 1" class="NormalDisplay">
      <div class="None firm-clickable" v-if="data.length == 0" @click="handelClickEDITOR()">
        待添加
      </div>
      <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="top-threeRows">
          <p class="CompanyName">{{ item.projectName }}</p>
          <p>{{ item.startTime }} 至 {{ item.endTime }}</p>
          <div class="icon firm-clickable" @click="handelClickSingle(item, index)"></div>
        </div>
        <p class="Position">{{ item.positionName }}</p>

        <div class="Description">负责项目内容描述：</div>

        <ul class="ul-performance">
          {{
            item.projectContent
          }}
          <!-- <li v-for="(item2, index) in item.projectContent" :key="index">
            {{ item2 }}
          </li> -->
        </ul>
      </div>
    </div>
    <!-- 展示编辑栏 -->
    <div v-if="IndividualEdit == 2" class="StartEditing">
      <div class="EDITOR-top">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="EDITOR-required">
            <div class="required-title-p">
              <p v-for="(item, index) in titleArr" :key="index">
                <span style="color: red">*</span>
                {{ item }}：
              </p>
            </div>
            <div class="required-ipt">
              <!-- 项目名称 -->
              <div class="input-place">
                <el-form-item prop="projectName">
                  <el-input
                    v-model="ruleForm.projectName"
                    placeholder="请输入项目名称"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 所担任职位 -->
              <div class="input-place" @click="handelExpect()">
                <el-form-item prop="positionName">
                  <el-input
                    v-model="ruleForm.positionName"
                    placeholder="请选择所担任职位"
                    readonly
                  ></el-input>
                </el-form-item>
              </div>

              <!-- 项目工期 -->
              <div class="input-place">
                <el-form-item prop="startTime" style="margin-right: 10px">
                  <el-date-picker
                    v-model="ruleForm.startTime"
                    type="date"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="startTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <p>至</p>
                <el-form-item prop="endTime" style="margin-left: 10px">
                  <el-date-picker
                    v-model="ruleForm.endTime"
                    type="date"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="endTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <!-- 右上删除按钮 -->
            <div class="required-dele">
              <div class="firm-clickable" @click="handelDele" v-if="ApplyForAJob != '1'"></div>
            </div>
          </div>
          <!-- 项目负责内容 -->
          <div class="EDITOR-Description">
            <p><span style="color: red">*</span>负责项目内容：</p>
            <div class="EDITOR-top-ipt">
              <el-form-item prop="projectContent">
                <el-input
                  type="textarea"
                  placeholder="请输入至少30个字的项目内容"
                  v-model="ruleForm.projectContent"
                  maxlength="3000"
                  show-word-limit

                  resize="none"
                  :autosize="true"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
    <!-- 职位 -->
    <Position
      :PositionAndProfession="PositionAndProfession"
      :positionCode="ruleForm.positionCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Position>
  </div>
</template>

<script>
// 引入接口
import {
  addUserProjectExp, // 添加
  editUserProjectExp, // 编辑
  deleteUserProjectExp, //删除
} from "../../../../../../assets/api/CenterJane";
// /职位选择弹窗
import Position from "../../../../../../components/Position.vue";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  // 接收父组件传的数据
  props: {
    data: {},
  },
  data() {
    return {
      IndividualEdit: 1, // 单条编辑
      titleArr: ["项目名称", "所担任职位", "项目工期"], // 编辑栏input右侧标题

      ruleForm: {
        userId: "",
        projectContent: "", // 内容描述框输入的值
        projectName: "", // 项目名称
        positionName: "", // 所担任职位
        positionCode: "", // 所担任职位的code
        startTime: "", //工期1
        endTime: "", //工期2
      }, // v-mode
      endTimePickerOptions: {
        disabledDate: (time) => {
          // 如果还没选开始时间 → 不限制
          if (!this.ruleForm.startTime) return false;

          // 已经选了开始时间 → 禁用 早于 startTime 的月份
          const startTime = new Date(this.ruleForm.startTime);
          return time.getTime() < startTime.getTime();
        },
      },
      startTimePickerOptions: {
        disabledDate: (time) => {
          if (!this.ruleForm.endTime) return false;
          const end = new Date(this.ruleForm.endTime);
          return time.getTime() > end.getTime();
        },
      },
      rules: {
        // projectName: vxRule(true, "", ["blur", "change"]),
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            max: 30,
            message: "请输入30字以内！",
            trigger: ["blur", "change"],
          },
        ],
        positionName: vxRule(true, "", ["blur", "change"], "请选择所担任职位"),
        startTime: vxRule(true, "", ["blur", "change"], "请选择项目开始时间"),
        endTime: vxRule(true, "", ["blur", "change"], "请选择项目结束时间"),
        // projectContent: vxRule(true, "", ["blur", "change"]),
        projectContent: [
          {
            required: true,
            min: 30,
            message: "请输入至少30字的项目内容！",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      value: "",
      value1: "",
      options: [], // 担任职位选项

      PositionAndProfession: false, //选择职位弹窗
      ApplyForAJob: "", // 为1时说明是在添加新的求职意向
      index: "", // 点击编辑时获取值，知道编辑的是哪一个
    };
  },
  created() {},
  components: { Position },
  methods: {
    // --------------------------------------点击选择 职位
    handelExpect() {
      // 打开弹窗
      console.log("44555");
      this.PositionAndProfession = true;
    },
    // -------------------------------------选择职位 弹窗关闭
    handleClose() {
      // 0关闭职位选择弹窗
      this.PositionAndProfession = !this.PositionAndProfession;
    },
    //-----------------------------------选择职位 弹窗确认
    handleUnderstand(num, val, valTwe) {
      console.log(num, val, valTwe, "11111");
      this.ruleForm.positionName = valTwe;
      this.ruleForm.positionCode = val;
      this.PositionAndProfession = !this.PositionAndProfession;
    },
    // 点击编辑单条数据
    handelClickSingle(item, index) {
      console.log(item, "4554");
      this.index = item.id; // 获取要编辑的数据位置
      let newArr1 = JSON.parse(JSON.stringify(item));
      this.ruleForm = newArr1;
      this.IndividualEdit = 2;
      this.ApplyForAJob = "";
    },
    // 点击清除
    handelDele() {
      this.$confirmWithScroll("是否删除本条信息?", "提示").then(() => {
        var data = {
          data: {
            id: this.index,
          },
        };
        deleteUserProjectExp(data).then((res) => {
          if (res.code == 0) {
            this.IndividualEdit = 1;
            this.ApplyForAJob = "";
            this.index = "";
            this.$emit("handelSubmitEdit");
            this.$tool.PromptBox("success", "修改成功");
          }
        });
      }).catch(() => {});
    },
    // ---------------------------------- 点击添加
    handelClickEDITOR() {
      this.ruleForm = {
        userId: "",
        projectContent: "", // 内容描述框输入的值
        projectName: "", // 项目名称
        positionName: "", // 所担任职位
        positionCode: "", // 所担任职位的code
        startTime: "", //工期1
        endTime: "", //工期2
      }; // v-mode
      this.IndividualEdit = "2";

      // 选择框数据
      this.ApplyForAJob = "1";
    },
    // 取消编辑
    handelUnEdit() {
      this.$emit("handelUnEdit", 5);
      // 点击取消时在子组件内先关闭子组件的展开编辑数据this.IndividualEdit
      this.IndividualEdit = 1;
    },
    // 编辑提交
    handelSubmitEdit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.projectContent.length >= 30) {
            if (this.ApplyForAJob == "") {
              // this.ApplyForAJob == ""时为编辑在原来的数据上修改
              var data = {};
              this.ruleForm.id = this.index;
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;
              // 调用接口修改简历个人信息
              editUserProjectExp(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            } else {
              // 为添加，在原来的数据前新增一条
              var data = {};
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;
              // 调用接口修改简历个人信息
              addUserProjectExp(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            }
          } else {
            this.$tool.PromptBox("warning", "至少输入30字的项目描述");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
// 文本输入框的样式
/deep/.el-textarea {
  min-height: 60px !important;
  
}
/deep/.el-textarea__inner {
  min-height: 80px !important;
}
//
/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}
/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// input 框内的icon
/deep/.el-input__icon {
  font-size: 20px !important;
  // margin-top: -3px;
}
// select框的icon
/deep/.el-icon-arrow-up {
  margin-top: 0px;
}
// select框鼠标悬浮
/deep/.el-input__inner:hover {
  border: 1px solid #409eff ;
}
/deep/.el-input__inner {
  width: 360px;
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  //   border-radius: 5px;
  //   border-right: none;
}
// 文本框最小高度
/deep/.el-textarea {
  min-height: 30px !important;
  position: relative;
}

// 正常展示数据
.normal {
  width: 100%;
  min-height: 25px;
  position: relative;
  border: 1px solid transparent;
}
// 展示编辑栏
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}
// 添加icon样式
.Title-Add-box {
  display: flex;
  position: absolute;
  font-size: 12px;
  top: -45px;
  left: 80px;
}
.Title-Add {
  width: 18px;
  height: 18px;
  background-image: url("../../../../../../assets/imgs/tianjia@2x.svg");
  background-size: 100% 100%;
  margin: auto 0;
  margin-left: 30px;
  margin-right: 5px;
}
// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  .normal-show:nth-child(1) {
    margin-top: 0px;
  }
  // 有数据正常展示
  .normal-show {
    width: 900px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    overflow-wrap: break-word;
    margin-top: 20px;
    .top-threeRows {
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin-bottom: 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      display: flex;
      .skill {
        min-width: 65px;
        height: 23px;
        background: #eeeeee;
        border-radius: 5px;
        text-align: center;
      }
      p {
        margin-right: 20px;
      }
      .CompanyName {
        font-size: 16px;
      }
      .icon {
        width: 18px;
        height: 18px;
        margin: auto 0;
        background-image: url("../../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
      }
    }
    // 担任职位
    .Position {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
    }
    // ul文字大小
    .ul-performance {
      font-size: 12px;
    }
    .Description {
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
// 开始编辑
.StartEditing {
  // flex: 1;
  // min-height: 200px;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  //
  .EDITOR-top {
    width: 100%;
    margin-bottom: 20px;
    .EDITOR-required {
      width: 100%;
      min-height: 30px;
      display: flex;
      // input框右侧标题
      .required-title-p {
        min-width: 50px;
        text-align: right;
        p {
          height: 35px;
          line-height: 35px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
      // input框
      .required-ipt {
        width: 350px;
        .input-place {
          width: 100%;
          height: 35px;
          margin-top: 25px;
          display: flex;
          position: relative;
          p {
            width: 60px;
            line-height: 35px;
            text-align: center;
            font-size: 14px;
          }
        }
        .input-place:nth-child(1) {
          margin-top: 0;
        }
      }
      // 删除按钮
      .required-dele {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
    .EDITOR-Description {
      width: 100%;
      min-height: 30px;
      .EDITOR-top-ipt {
        width: 100%;
        min-height: 30px;
      }
      p {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }
  }
  // 编辑栏下方按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
